import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatBottomSheetService } from 'src/app/services/mat-bottom-sheet.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FooterComponent {
  private _matBottomSheetService = inject(MatBottomSheetService);

  public handleCloseOnClick(): void {
    this._matBottomSheetService.closeAllMatBottomSheets();  
  }
}
